var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEdit(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20H4.1661L16.4533 7.71278L12.2872 3.54668L0 15.8339V20ZM2.22192 16.756L12.2872 6.6907L13.3093 7.71278L3.244 17.7781H2.22192V16.756ZM17.0755 0.324894C16.9727 0.221904 16.8506 0.140195 16.7162 0.0844457C16.5818 0.0286961 16.4377 0 16.2922 0C16.1467 0 16.0027 0.0286961 15.8683 0.0844457C15.7339 0.140195 15.6118 0.221904 15.509 0.324894L13.4759 2.35795L17.642 6.52405L19.6751 4.491C19.7781 4.38822 19.8598 4.26613 19.9156 4.13174C19.9713 3.99734 20 3.85327 20 3.70777C20 3.56227 19.9713 3.4182 19.9156 3.2838C19.8598 3.1494 19.7781 3.02732 19.6751 2.92454L17.0755 0.324894Z",
    fill: "#505358"
  })));
}

export default SvgEdit;